module.exports = {
  name: 'menu-list-3',
  listClass: 'menu-list menu-list-3-cols',
  defaultLimit: 100,
  columns: 3,
  itemIndexes: 'id'
}
